<template>
    <div class="project">
        <advertising-figure :bannerSrc="bannerSrc"/>
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Overview of the meeting</span>
            </public-title>

            <div class="divider">
                <h2 class="tit">嘉宾介绍</h2>
                <span class="time">发布日期: 2022-1-15</span>
            </div>

            <div class="guest-wrap">
                <div class="guest">
                    <ul class="guest-list"  >
                        <li class="guest-item" v-for="(item,i) in guests" :key="i">
                            <div class="guest-img" v-if = "item.image !== null"  @click="jumpTo(item)">
                                <img style ="width:150px" :src="item.image[0].url" alt="" />
                            </div>
                            <div class="guest-info"  @click="jumpTo(item)">
                                <h2 class="tit">{{item.name}}</h2>
                                <p class="info">查看介绍信息</p>
                            </div>
                        </li>
                        <!-- <li class="guest-item">
                            <div class="guest-img">
                                <img src="@assets/img/guest.jpg" alt="" />
                            </div>
                            <div class="guest-info">
                                <h2 class="tit">重要嘉宾</h2>
                                <p class="info">嘉宾信息介绍</p>
                            </div>
                        </li>
                        
                        <li class="guest-item">
                            <div class="guest-img">
                                <img src="@assets/img/guest.jpg" alt="" />
                            </div>
                            <div class="guest-info">
                                <h2 class="tit">重要嘉宾</h2>
                                <p class="info">嘉宾信息介绍</p>
                            </div>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";
import CurrentConferMixin from "@/mixin/CurrentConference"

export default {
    name: "VenuePage",
    components: {
        AdvertisingFigure,
        InnerPageNav,
        publicTitle,
    },
    mixins: [CurrentConferMixin],
    data() {
        return {
            bannerSrc:require("@assets/img/meeting-banner.png"),
            title: "会议概况",
        };
    },
    computed:{
        guests(){
            if(this.currentConference.guests){
                let guests = [...this.currentConference.guests];
                guests = guests.sort((a,b)=>a.order-b.order)
                return guests
            }
        }
    },
    methods: {
        jumpTo(item) {
            this.$router.push({
                name: "GuestDetailPage",
                params:{guest:item},
                query:{guest_id:item.id}
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
        position: relative;
        font-size: 18px;
        color: #666;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 2px;
            background: $defaultColor;
        }
    }

    .time {
        font-size: 14px;
        color: #999;
    }
}

.guest-wrap {
    width: 1200px;
    margin: 0 auto;
}

.guest {
    padding: 30px;
    margin-bottom: 30px;
    min-height: 180px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    .guest-list {
        @include flex-start;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        gap: 25px 25px;

        .guest-item {
            flex: 0 0 18%;
        }

        .guest-img {
            width: 100%;

            img {
                width: 100%;
            }
        }

        .guest-info {
            padding: 10px;
            .tit {
                font-size: 16px;
                color: #003a8c;
            }

            .info {
                font-size: 14px;
                color: #666;
                margin-top: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>